var React = require('react');

function DefaultIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.5332 8.66332L7.05701 13.1871L15.1999 5.04428L13.9241 3.75952L7.05701 10.6267L3.80892 7.38761L2.5332 8.66332Z","fill":"#1D70F2"}));
}

DefaultIcon.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = DefaultIcon;

DefaultIcon.default = DefaultIcon;
